import { render, staticRenderFns } from "./ResearchRequestReader.vue?vue&type=template&id=3f4602c7"
import script from "./ResearchRequestReader.vue?vue&type=script&lang=js"
export * from "./ResearchRequestReader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f4602c7')) {
      api.createRecord('3f4602c7', component.options)
    } else {
      api.reload('3f4602c7', component.options)
    }
    module.hot.accept("./ResearchRequestReader.vue?vue&type=template&id=3f4602c7", function () {
      api.rerender('3f4602c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/research/ResearchRequestReader.vue"
export default component.exports